import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.component('GmapMap', VueGoogleMaps.Map);
Vue.component('GmapMarker', VueGoogleMaps.Marker);
Vue.component('GmapCluster', VueGoogleMaps.Cluster);
Vue.component('GmapInfoWindow', VueGoogleMaps.InfoWindow);
Vue.component('GmapPolyline', VueGoogleMaps.Polyline);
Vue.component('GmapPolygon', VueGoogleMaps.Polygon);
Vue.component('GmapCircle', VueGoogleMaps.Circle);
Vue.component('GmapRectangle', VueGoogleMaps.Rectangle);
Vue.component('GmapAutocomplete', VueGoogleMaps.Autocomplete);
Vue.component('GmapPlaceInput', VueGoogleMaps.PlaceInput);
Vue.component('GmapStreetViewPanorama', VueGoogleMaps.StreetViewPanorama);

export default {
  loadGmap() {
    Vue.use(VueGoogleMaps, {
      load: {
        key: 'AIzaSyBFzmkZZI49yM5KfLub-b5g5dmtsTosTDA',
        v: '3.exp',
        libraries: 'visualization'
      },
      installComponents: false
    })
    return VueGoogleMaps.loaded
  }
}


// WEBPACK FOOTER //
// ./src/utils/GmapLazy.js